// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer--2PskT","logo":"logo--2rVQ9","link":"link--pSHIq"};